var App = App || {};

App.Community = (function ($) {
    'use strict';

    function Init(selector) {
        if (selector.length) {
            selector.each(function () {
                const widget = $(this);
                const splideElement = widget.find('.splide');

                InitParallax(widget);
                InitTickerCounter(widget);

                if (splideElement.length) {
                    const splide = new Splide(splideElement[0], {
                        type: 'loop',
                        direction: 'rtl',
                        perPage: 2,
                        perMove: 1,
                        gap: '2.5rem',
                        fixedWidth: '31.8rem',
                        focus: 0,
                        trimSpace: false,
                        padding: {
                            left: 0,
                            right: 0
                        },
                        arrows: true,
                        pagination: false,
                        autoplay: false,
                        breakpoints: {
                            768: {
                                perPage: 1,
                                perMove: 1,
                                gap: '1rem',
                                trimSpace: false,
                                fixedWidth: '17.97rem',
                                focus: 0,
                                padding: {
                                    left: 0,
                                    right: 0
                                }
                            },
                            992: {
                                trimSpace: false,
                                perPage: 2,
                                gap: '2.5rem',
                                fixedWidth: '17.97rem',
                                focus: 0,
                                padding: {
                                    left: 0,
                                    right: 0
                                }
                            }
                        }
                    });

                    splide.mount();
                }
            });
        }
    }

    function InitParallax(widget) {
        const backgroundLayer = widget.children('.widget-community__background-layer');

        if (backgroundLayer.children('.widget-community__background-image.zag-parallax-bg').length) {
            backgroundLayer.ZagParallax({ divisor: 2 });
        }
    }

    function InitTickerCounter(widget) {
        const items = widget.find('.community-ticker .ticker-number');

        if (!items.length || typeof Waypoint === 'undefined' || typeof countUp === 'undefined') {
            return;
        }

        items.each(function () {
            const parsed = ParseTickerValue($(this).text());

            if (!parsed) {
                return;
            }

            $(this).data('counterEnd', parsed.end);
            $(this).data('counterPrefix', parsed.prefix);
            $(this).data('counterSuffix', parsed.suffix);
            $(this).data('counterDecimals', parsed.decimals);
            $(this).text('0');
        });

        new Waypoint({
            element: widget[0],
            handler: function (direction) {
                if (direction === 'down') {
                    StartTickerCounter(items);
                    this.destroy();
                }
            },
            offset: '75%'
        });
    }

    function StartTickerCounter(items) {
        items.each(function () {
            const tickerNumber = $(this);
            const end = tickerNumber.data('counterEnd');

            if (typeof end === 'undefined') {
                return;
            }

            const counter = new countUp.CountUp(this, end, {
                startVal: 0,
                decimalPlaces: tickerNumber.data('counterDecimals') || 0,
                duration: 2,
                useGrouping: true,
                separator: ',',
                prefix: tickerNumber.data('counterPrefix') || '',
                suffix: tickerNumber.data('counterSuffix') || ''
            });

            if (!counter.error) {
                counter.start();
            }
        });
    }

    function ParseTickerValue(rawValue) {
        const value = (rawValue || '').trim();
        const match = value.match(/^([^\d\-\.]*)(-?[\d,]*\.?\d+)([^\d\.]*)$/);

        if (!match) {
            return null;
        }

        const prefix = (match[1] || '').trim();
        const numericPart = (match[2] || '').replace(/,/g, '');
        const suffix = (match[3] || '').trim();

        if (!numericPart.length) {
            return null;
        }

        const end = parseFloat(numericPart);
        if (Number.isNaN(end)) {
            return null;
        }

        const decimals = numericPart.includes('.') ? numericPart.split('.')[1].length : 0;

        return {
            end: end,
            decimals: decimals,
            prefix: prefix,
            suffix: suffix
        };
    }

    return {
        Init: Init
    };

})(jQuery);

$(function () {
    App.Community.Init($('.widget-community'));
});
